<template>
	<div id="login">
		<div class="bgposition"></div>
		<div class="left">
			<video id="v2" autoplay loop muted>
				<source src="../assets/mp4/ebs.mp4" type="video/mp4" />
			</video>
		</div>
		<div class="right">
			<div class="icon">
				<img src="../assets/img/logo.png" alt="" />
				<img src="../assets/img/mk3.0.png" alt="">
			</div>
			<div class="pingtai">让能源利用更安全、更简单</div>
			<div class="loginUser">
				<!-- <img v-show="!showScanQRcode" @click="showScanQRcode = !showScanQRcode" src="../assets/img/qrcode.png" alt="">
				<img v-show="showScanQRcode" @click="showScanQRcode = !showScanQRcode" src="../assets/img/prcodeon.png" alt=""> -->
				<div class="warp" v-if="!showScanQRcode">
					<p>欢迎使用e博视</p>
					<div class="tab">
						<span :class="loginIdx == 0 ? 'se' : ''" @click="tabLoginType(0)">密码登录</span>
						<span :class="loginIdx == 1 ? 'se' : ''" @click="tabLoginType(1)">验证码登录</span>
					</div>
					<div class="subForm" v-if="loginIdx == 0">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
							<el-form-item label="账号" prop="username">
								<el-input v-model.trim.number="ruleForm.username" placeholder="请输入手机号"
									onkeyup="value=value.replace(/[^\d]/g,'')" type="tel" autocomplete="off"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="password">
								<el-input :type="!isSee ? 'password' : 'text'"
									onkeyup="value=value.replace(/[^\x00-\xff]/g, '')" v-model.trim="ruleForm.password"
									placeholder="请输入密码" autocomplete="off"
									@keyup.enter.native="submit('ruleForm')"></el-input>
								<!-- <span class="positionPsd">忘记密码</span> -->
								<img class="passwordIcon" v-show="ruleForm.password.length > 0"
									:src="isSee ? require('../assets/img/cansee.png') : require('../assets/img/nosee.png')"
									@click="isCanSee" alt="">
							</el-form-item>
							<el-form-item>
								<div class="box">
									<el-checkbox v-model="ruleForm.checked">我已阅读并同意</el-checkbox>
									<a target="_blank" href="http://local.vrmaker.vip:38080/ebsAgreement.html"><span
											class="scolor">服务协议</span>和<span class="scolor">隐私协议</span></a>

								</div>
							</el-form-item>
							<el-form-item size="large">
								<el-button type="primary" @click="submit('ruleForm')">登录</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="subForm" v-if="loginIdx == 1">
						<el-form :model="ruleFormVerification" :rules="rules" ref="ruleFormVerification"
							class="demo-ruleForm">
							<el-form-item label="手机号" prop="tel">
								<el-input v-model.trim.number="ruleFormVerification.tel" placeholder="请输入手机号"
									onkeyup="value=value.replace(/[^\d]/g,'')" type="tel" autocomplete="off"></el-input>
							</el-form-item>
							<el-form-item label="验证码" prop="code">
								<el-input type="text" v-model.trim="ruleFormVerification.code" maxlength="6"
									onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入短信验证码"
									autocomplete="off"></el-input>
								<span class="Verification" @click="getCode('ruleFormVerification')"
									v-show="!isSend">获取验证码</span>
								<span class="Verification" v-show="isSend">请{{ sendTime }}秒后再试</span>
							</el-form-item>
							<el-form-item>
								<div class="box">
									<el-checkbox v-model="ruleFormVerification.checked">我已阅读并同意</el-checkbox>
									<a target="_blank" href="http://local.vrmaker.vip:38080/ebsAgreement.html"><span
											class="scolor">服务协议</span>和<span class="scolor">隐私协议</span></a>

								</div>
							</el-form-item>
							<el-form-item size="large">
								<el-button type="primary" @click="submitVerification('ruleFormVerification')">登录</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="scanqrCode" v-if="showScanQRcode">
					<p>欢迎使用e博视</p>
					<div class="rqcode">
						<img src="../assets/img/logoQR.png" alt="">
					</div>
					<div class="sacn">
						<img src="../assets/img/scanqrcode.png" alt="">
						<div class="scanlogin">
							<p>打开微信</p>
							<p>扫码登录</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer>
			<div>
				<img src="../assets/img/logov3.png" alt="">
			</div>
			<div>版权 © 2021 - {{ new Date().getFullYear() }} 武汉魅客科技出品 <a target="_blank"
					href="https://beian.miit.gov.cn/#/Integrated/index">鄂ICP备17022551号-2</a></div>
		</footer>
	</div>
</template>

<script>
import { play } from '../api/login'
import { userAllgroup, firmInfo } from '../api/power.js'
import { debounce1 } from '../util/Debounce'
export default {
	name: "Login",
	data() {
		var checkuser = (rule, value, callback) => {
			var phoneReg = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
			if (value === '') {
				callback(new Error('请输入手机号'));
			} else {
				if (!phoneReg.test(value)) {
					callback(new Error('手机号格式错误'));
				} else {
					callback();
				}
				callback();
			}
		};
		var checkpsd = (rule, value, callback) => {
			if (value === "") {
				return callback(new Error("请输入密码"));
			} else {
				if (this.ruleForm.password.length < 6 || this.ruleForm.password.length > 13) {
					return callback(new Error("请输入6-13位字符"));
				}
				callback();
			}
		};
		// var checkcode = (rule, value, callback) => {
		//     if (value === "") {
		// 		return callback(new Error("请输入验证码"));
		// 		} else {
		// 		if (this.ruleFormVerification.code.length !== 6 ) {
		// 			return  callback(new Error("请输入6位数验证码"));
		// 		}
		// 		callback();
		// 	}
		// };
		return {
			loginIdx: 0,  // 登录类型切换
			showScanQRcode: false,  // 展示扫码登录 
			ruleForm: {
				username: '',
				password: '',
				checked: true
			},
			isSee: false, // 密码是否可见
			rules: {
				username: [{
					validator: checkuser,
					trigger: "change"
				}],
				password: [{
					validator: checkpsd,
					trigger: "change"
				}],
				tel: [{
					validator: checkuser,
					trigger: "change"
				}],
				// code:[{
				// 	validator: checkcode,
				//     trigger: "change"
				// }]
			},
			ruleFormVerification: {
				tel: '',
				code: '',
				key: '',
				checked: true
			},
			isSend: false, // 正在发送验证码
			sendTime: 60, // 倒计时
			timer: null,
			de: null
		}
	},
	components: {},
	mounted() {
		this.de = debounce1(this.getCode1, 5000)
	},
	methods: {
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let loginUser = {
						tel: this.ruleForm.username,
						psw: this.ruleForm.password,
					}
					play.login(loginUser).then(res => {
						console.log(res);
						if (res.data.code == 200) {
							if (res.data.data.token) {
								this.$message({
									message: res.data.msg,
									type: 'success'
								})
								this.loginSuccess(res)
								this.$cookies.set('logincookies', res)
								this.$cookies.set('isLogin', true)
							} else {
								this.$message({
									message: res.data.msg,
									type: 'success'
								})
							}
						} else {
							this.$message.error(res.data.errMsg);
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		loginSuccess(res) {


			let token = res.data.data.token;
			this.$store.commit("setToken", token);
			window.sessionStorage.setItem('token', token)
			// 刷新 token
			setInterval(() => {
				play.freshToken().then((res) => {
					this.$store.commit("setToken", res.data.data
						.token);
				});
			}, 45 * 60 * 1000);



			this.$store.commit("setUser", res.data.data.user);
			this.$store.commit("setProjectId", res.data.data.user.firmId);
			userAllgroup(res.data.data.user.uid).then((res) => {
				if (res.data.status) {

					let projectGroup = res.data.data
					// let areaId = projectGroup[0].projectList[0].areaList[0].areaId
					let projectId = projectGroup[0].projectList[0].projectId

					this.$store.commit("setProjectId", projectId);
					let newprojectGroup = projectGroup.filter(e => { if (e.firmId != projectGroup[0].firmId) return e })
					this.$store.commit("setProjectGroup", projectGroup);
					// this.$store.commit("setAreaInfo", projectGroup[0].projectList[0].areaList[0]);
					this.$store.commit("setEnterpriseInfo", projectGroup[0]);

					this.$store.commit(
						"setProjectInfo",
						projectGroup[0].projectList[0]
					);

					this.getWeatherInfo();
					sessionStorage.setItem('isSelect', "Overview")
					this.$router.push("/Home/Overview/SubstationManagement");

				} else {
					this.$message.error(res.data.errMsg);
				}

			})

			//判断前后台数据
			this.$store.commit("ForegroundRadio", this.ruleForm.radio1);
			this.$store.commit("NavformDataId", 1);
			sessionStorage.setItem("NavformDataId", 1)
		},
		getWeatherInfo() {
			let WeatherInfo = {}
			fetch('https://devapi.heweather.net/v7/weather/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
				'&key=aa0dc97c8180424b91a79c7a0fe136ef')
				.then(response => response.json())
				.then(json => {
					WeatherInfo.text = json.now.text
					WeatherInfo.temp = json.now.temp
					WeatherInfo.humidity = json.now.humidity
					this.$store.commit("setWeatherInfo", WeatherInfo);
				})
			fetch('https://devapi.qweather.com/v7/air/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
				'&key=aa0dc97c8180424b91a79c7a0fe136ef')
				.then(response => response.json())
				.then(json => {
					WeatherInfo.category = json.now.category;
					this.$store.commit("setWeatherInfo", WeatherInfo);
				})
		},
		tabLoginType(idx) {
			this.loginIdx = idx
		},
		submitVerification(formName) {
			let _this = this
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(_this.ruleFormVerification);
					play.verificationLogin({
						tel: _this.ruleFormVerification.tel,
						key: _this.ruleFormVerification.key,
						code: _this.ruleFormVerification.code
					}).then(res => {
						if (res.data.code == 200) {
							if (res.data.data.token) {
								this.$message({
									message: res.data.msg,
									type: 'success'
								})
								this.loginSuccess(res)
								this.$cookies.set('logincookies', res)
								this.$cookies.set('isLogin', true)
							} else {
								this.$message({
									message: res.data.msg,
									type: 'success'
								})
							}
						} else {
							this.$message.error(res.data.errMsg);
						}
					})

				}
			})

		},
		getCode(formName) {
			let _this = this

			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.de()
				}
			})


		},
		getCode1() {
			let _this = this
			play.getKeyVerification({
				tel: _this.ruleFormVerification.tel
			}).then(code => {
				if (code.data.code == 200) {
					_this.ruleFormVerification.key = code.data.data.key
					this.$message({
						message: code.data.msg,
						type: 'success'
					})
					_this.sendCode()
				} else {
					this.$message.error(code.data.errMsg);
				}
			}).catch(err => {
				console.log(err);
			})
		},
		sendCode() {
			this.isSend = true
			let _this = this
			if (this.timer) {
				clearInterval(_this.timer)
			}
			this.timer = setInterval(() => {

				if (_this.sendTime > 0) {
					_this.sendTime--
				} else {
					clearInterval(_this.timer)
					_this.timer = null
					_this.isSend = false
					_this.sendTime = 60
					console.log(_this.sendTime);

				}
			}, 1000)
		},
		isCanSee() {
			this.isSee = !this.isSee


			
		}
	}
}
</script>

<style lang="less" scoped>
#login {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	position: relative;
	padding: 0 10vw;

	.bgposition {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding: 0 10vw;
		background: url(../assets/img/loginBJ1.png) no-repeat;
		background-size: 100% 100%;
		z-index: 20;
	}

	.left {
		float: left;
		width: 40vw;
		height: 75vh;
		margin-top: 12vh;
		z-index: 9;

		video {
			width: 100%;
			height: 100%;
		}
	}

	.right {
		// float: left;
		position: absolute;
		right: 10vw;
		top: 0;
		width: 38vw;
		margin-top: 11vh;
		z-index: 30;

		.icon {
			// margin-left: 235px;
			margin-left: 12.2vw;
			position: relative;

			&>img:nth-child(1) {
				width: 15.1vw;
				height: 9.3vh;
			}

			&>img:nth-child(2) {
				position: absolute;
				top: 10rem;
				left: 14.8vw;
				width: 3vw;
				height: 3.5vh;
			}
		}

		.pingtai {
			margin-left: 12.3vw;
			margin-top: 2.5vh;
			font-size: 0.95vw;
			font-weight: 400;
			color: #0D94FF;
			letter-spacing: 0.57vw;
		}

		.loginUser {
			.w(600);
			height: 45vh;
			margin-top: 8vh;
			margin-left: 6.5vw;
			border-radius: 12px;
			background-color: #fff;
			box-shadow: 0px 7px 42px 0px rgba(0, 0, 0, 0.04);
			padding: 6vh 6.25vw 0;
			position: relative;

			&>img {
				position: absolute;
				top: 10rem;
				right: 10rem;
				cursor: pointer;
				height: 4vh;
				width: 2vw;
			}

			p {
				font-size: 24rem;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #333333;
				padding-bottom: 5rem;
			}

			.tab {
				height: 5vh;
				line-height: 5vh;
				box-sizing: border-box;
				display: flex;

				&>span {
					display: inline-block;
					padding: 0 5rem;
					height: 100%;
					font-size: 18rem;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #333333;
					margin-right: 2vw;
					cursor: pointer;
				}

				.se {
					position: relative;
					font-weight: bold;

					&::before {
						content: '';
						width: 100%;
						height: 5rem;
						background: #0D94FF;
						position: absolute;
						bottom: 0;
						left: 0;
						border-radius: 2px;
					}
				}
			}

			.subForm {
				padding: 1vh 0;

				.box {
					height: 5vh;
					line-height: 5vh;

					&>a {
						font-size: 14px;
						color: #666;
						text-decoration: none;
					}

					.scolor {
						color: #0D94FF;
					}
				}

				.positionPsd {
					position: absolute;
					right: 24px;
					top: 33px;
					font-size: 18rem;
					color: #999;
					font-weight: 400;
					font-family: Source Han Sans CN;
				}

				/deep/.el-form-item__content {
					margin-left: 0 !important;
					line-height: 4vh;
					height: 4vh;
				}

				/deep/.el-input__inner {
					border: none;
					outline: none;
					font-size: 18rem;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #666666;
					border-bottom: 1px solid rgba(0, 0, 0, 0.15);
					margin-left: 0;
					height: 4vh;
					line-height: 4vh;
				}

				/deep/.el-form-item__error {
					padding-top: 5rem;
					padding-left: 0;
					z-index: 11;
					font-size: 10rem;
				}

				.el-form-item {
					position: relative;
					margin-bottom: 1vh;

					.passwordIcon {
						position: absolute;
						right: 0;
						top: 50%;
						transform: translate(-50%, -50%);
					}

				}

				// /deep/.el-icon-view:before {
				// 	font-size: 20rem;
				// }
				/deep/.el-form-item__label {
					width: 7.82vw !important;
					position: absolute;
					top: 1vh;
					left: 0;
					font-size: 0.94vw;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #333;
					display: none;
				}

				/deep/.el-button--primary {
					width: 100%;
					height: 4.3vh;
					line-height: 4.3vh;
					margin-top: 0.5vh;
					font-size: 16px;
					padding: 0;
				}

				/deep/.el-checkbox__label {
					color: #666;
					font-size: 14px;
				}

				.Verification {
					position: absolute;
					right: 0;
					top: 0;
					font-size: 16rem;
					font-weight: bold;
					color: #0D94FF;
					cursor: pointer;
				}

			}
		}

		.scanqrCode {
			width: 100%;
			height: 100%;
			text-align: center;

			&>p {
				padding-bottom: 6vh;
			}

			.rqcode {
				width: 9.4vw;
				height: 18.6vh;
				box-shadow: 0px 0px 16px 0px rgba(8, 42, 93, 0.24);
				margin: auto;

				&>img {
					width: 100%;
					height: 100%;
				}
			}

			.sacn {
				height: 9vh;
				display: flex;
				justify-content: center;
				align-items: center;

				&>img {
					width: 2.1vw;
					height: 4vh;
				}

				.scanlogin {
					height: 4vh;

					&>p {
						height: 2vh;
						line-height: 2vh;
						padding-left: 0.5vw;
						font-size: 18rem;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #333333;
					}
				}
			}
		}
	}

	footer {
		// width: 280px;
		position: absolute;
		bottom: 4.6vh;
		left: 42vw;
		z-index: 30;

		div {
			font-size: 16rem;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #999;
			text-align: center;

			a {
				color: #999;
				font-family: Source Han Sans CN;
				text-decoration: none;
			}

			a:hover {
				color: #0d94ff;
			}
		}
	}
}</style>